import { ResidentMedicationsTemplate } from "app/features/medications/templates/ResidentMedicationsTemplate";

export function ResidentMedicationsScreen() {
  return <ResidentMedicationsTemplate />;
}
